import { enumValues } from "@adora/shared/utils/enum";

export type Platform = "meta" | "google" | "msan" | "pinterest" | "reddit" | "tiktok";
export type UIPlatformName = "GDN" | "Meta" | "MSAN" | "Pinterest" | "Reddit" | "TikTok";
export const PLATFORMS: Record<string, Platform> = {
  GDN: "google",
  META: "meta",
  MSAN: "msan",
  PINTEREST: "pinterest",
  REDDIT: "reddit",
  TIKTOK: "tiktok"
} as const;

export const URL_PARAM_PLATFORMS: Record<string, UIPlatformName> = {
  google: "GDN",
  meta: "Meta",
  msan: "MSAN",
  pinterest: "Pinterest",
  reddit: "Reddit",
  tiktok: "TikTok"
} as const;

export type COMMON_PLATFORMS_CAPITALIZED = "GDN" | "META" | "MSAN";
export type ALL_PLATFORM_KEYS = "GDN" | "META" | "MSAN" | "PINTEREST" | "REDDIT" | "TIKTOK";
export const PLATFORM_SELECTOR_DISPLAY_NAMES: Record<ALL_PLATFORM_KEYS, string> = {
  GDN: "Google Display Network",
  META: "Meta",
  MSAN: "Microsoft Audience Network",
  PINTEREST: "Pinterest",
  REDDIT: "Reddit",
  TIKTOK: "TikTok"
} as const;

/** Ordered list of all platform keys — single source of truth for UI iteration. */
// TikTok is available in the publishing workflow for explicitly configured
// brands, but is not yet offered in the general new-project platform picker.
export const ALL_PLATFORMS: Platform[] = ["meta", "google", "msan", "pinterest"];

export function isPlatform(str: string): str is Platform {
  return enumValues(PLATFORMS).includes(str as Platform);
}

export type PlatformKey = keyof typeof PLATFORMS;

export enum PlatformEnum {
  GDN = "google",
  META = "meta",
  MSAN = "msan",
  PINTEREST = "pinterest",
  REDDIT = "reddit",
  TIKTOK = "tiktok"
}
